<fgb-account-layout [memberName]="name() ?? ''" [pageTitle]="'account.activity.page.title'" [backButtonLink]="'/'">
  <div class="container mb-2 mt-lg-4">
    <ng-container *inProductCode="[productCode.Free]">
      <fgb-upgrade-banner></fgb-upgrade-banner>
    </ng-container>

    <div class="row">
      <div class="col-12 col-lg-6 order-lg-1 order-1">
        <h5 class="my-3 mt-0 section-title font-page-heading text-uppercase">{{ 'account.details.title' | translate }}</h5>
        <fgb-account-details></fgb-account-details>
      </div>
      <div class="col-12 col-lg-6 order-lg-2 order-2">
        <h5 class="mb-3 mt-4 mt-lg-0 section-title font-page-heading text-uppercase">{{ 'login.details.title' | translate }}</h5>
        <div class="item-container">
          <fgb-edit-login-details />
        </div>

        <div class="item-container d-lg-none d-flex">
          <ng-container *ngTemplateOutlet="cardTemplate"></ng-container>
        </div>
        <div class="item-container d-none d-lg-flex">
          <ng-container *ngTemplateOutlet="cardTemplate"></ng-container>
        </div>
      </div>
    </div>
  </div>

  <ng-template #cardTemplate>
    <fgbcl-card-token-list
      [provider]="provider"
      [redirectUrl]="'/cardtoken/result'"
      [failureUrl]="'/cardtoken/failure'"
      [regex]="regex"
    ></fgbcl-card-token-list>
  </ng-template>
</fgb-account-layout>
